import { Input } from '@appd/uik';

interface QueryBuilderCountSelectorProps {
  alias: string;
  onAliasChange: (e: string) => void;
}

export const QueryBuilderCountSelector = ({ alias, onAliasChange }: QueryBuilderCountSelectorProps) => {
  return (
    <div className="flex grow flex-row divide-x rounded-md border-2 mt-2 py-2">
      <div className="text-base w-[70px] text-center">Count</div>
      <div className="min-w-[150px] pl-2 flex flex-row">
        <div className="pr-2">
          <div className="text-sm leading-5">Alias</div>
          <div className="text-base">
            <Input
              className="px-2 border-2 rounded-md truncate w-[80px]"
              style={{}}
              onChange={e => {
                onAliasChange(e.target.value);
              }}
              placeholder={'Enter ID Alias'}
              value={alias}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
